import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Reflejos from './Reflejos'
import Shooter from './Shooter'
import SnakeModal from './SnakeModal'

const JuegosList = () =>{
    return (
        <div className = "bg-svg py-4">
        <div className = "container mt-5">
            <div className = "text-white text-center">
                <h1>Videojuegos</h1>
                <p>Galería de minijuegos</p>
            </div>
            <Row  xs={1} md={3} className="g-4">
                <Col>
                    <SnakeModal/>
                </Col>
                <Col>
                    <Reflejos/>
                </Col>
                <Col>
                    <Shooter/>
                </Col>
            </Row>    
        </div>
             
        </div>
    )
}
export default JuegosList